import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { setDispatch } from './helpers/api';
import { HelmetProvider } from 'react-helmet-async';
import { PostHogProvider } from 'posthog-js/react';

setDispatch(store.dispatch);
const domNode = document.getElementById('root');
if (!domNode) {
  throw new Error('No root element found');
}
const root = createRoot(domNode);
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.VITE_PUBLIC_POSTHOG_KEY!}
      options={{
        // eslint-disable-next-line camelcase
        api_host: process.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        // eslint-disable-next-line camelcase
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        debug: process.env.MODE === 'development',
      }}
    >
      <HelmetProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </HelmetProvider>
    </PostHogProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
